export type PerfilUso = 'desenvolve' | 'homologa' | 'usa';
export type Ferramenta = 'a_definir' | 'codex' | 'claude' | 'ambos';
export type GithubStatus = 'nao_necessario' | 'aguardando_login' | 'login_informado' | 'convite_enviado' | 'aceito';
export type Repositorio = 'nexo' | 'dre-system' | 'toolbox';

// O GitHub aceita letras, números e hífens simples, sem hífen nas pontas.
export const GITHUB_LOGIN_PATTERN = /^(?!.*--)[A-Za-z0-9](?:[A-Za-z0-9-]{0,37}[A-Za-z0-9])?$/;

export function githubLoginValido(login?: string | null) {
  const valor = login?.trim() || '';
  return !valor || GITHUB_LOGIN_PATTERN.test(valor);
}

export function githubPerfilUrl(login?: string | null) {
  const valor = login?.trim() || '';
  return valor && githubLoginValido(valor) ? `https://github.com/${valor}` : null;
}

export const CHECKLIST_CHAVES = [
  'conta_github', 'dois_fatores', 'convite_github', 'ia_instalada', 'kit_preparado', 'primeira_entrega',
] as const;
export type ChecklistChave = typeof CHECKLIST_CHAVES[number];
export type Checklist = Record<ChecklistChave, boolean>;

export function checklistChavesDoPerfil(perfil: PerfilUso): readonly ChecklistChave[] {
  return perfil === 'desenvolve' ? CHECKLIST_CHAVES : ['kit_preparado', 'primeira_entrega'];
}

export interface Colaborador {
  id: string;
  usuario_erp_id: string;
  usuario_erp_ativo?: boolean;
  nome: string;
  email: string;
  github_login: string | null;
  perfil_uso: PerfilUso;
  ferramenta: Ferramenta;
  repositorios: Repositorio[];
  github_status: GithubStatus;
  plano_ia: string | null;
  observacoes: string | null;
  checklist: Checklist;
  acesso_liberado: boolean;
  revisao: number;
  criado_em?: string;
  atualizado_em?: string;
}

export interface UsuarioErp {
  id: string;
  nome: string;
  email: string;
  ativo: boolean;
}

export type Dominio = 'engenharia' | 'gestao' | 'transversal';
export type TipoCapacidade = 'rotina' | 'biblioteca' | 'api_mcp' | 'produto';
export type StatusVersao = 'rascunho' | 'em_homologacao' | 'homologada' | 'suspensa';

export interface PermissoesNexo {
  consultar: boolean;
  editar_acervo: boolean;
  homologar: boolean;
  gerenciar_colaboradores: boolean;
}

export interface CapacidadeSnapshot {
  codigo: string;
  nome: string;
  dominio: Dominio;
  tipo: TipoCapacidade;
  descricao: string;
  responsavel: string;
  repositorio: string;
}

export interface VersaoCapacidade {
  id: string;
  capacidade_id: string;
  versao: string;
  commit_sha: string;
  entradas: string;
  saidas: string;
  limites: string;
  execucao: string;
  evidencias: string;
  status: StatusVersao;
  revisao: number;
  homologado_por?: string | null;
  homologado_em?: string | null;
  parecer?: string | null;
  capacidade_snapshot?: CapacidadeSnapshot | null;
}

export interface Capacidade {
  id: string;
  codigo: string;
  nome: string;
  dominio: Dominio;
  tipo: TipoCapacidade;
  descricao: string;
  responsavel: string;
  repositorio: string;
  revisao: number;
  versoes: VersaoCapacidade[];
}

export interface InicioNexo {
  permissoes: PermissoesNexo;
  admin: boolean;
  email: string;
  participante: Colaborador | null;
  colaboradores: Colaborador[];
  usuarios_erp: UsuarioErp[];
  capacidades: Capacidade[];
}

export interface MaterialResumo {
  id: string;
  titulo: string;
  descricao: string;
  origem: string;
  revisao: number | string;
}

export interface Material extends MaterialResumo { conteudo: string }
export interface KitNexo { nome: string; revisao: number | string; arquivos: Array<{ caminho: string; conteudo: string }> }

export const checklistVazio = (): Checklist => ({
  conta_github: false,
  dois_fatores: false,
  convite_github: false,
  ia_instalada: false,
  kit_preparado: false,
  primeira_entrega: false,
});
